module.exports = __webpack_public_path__ + "static/media/SAMLP_MENU-normal.9cdf0748.png";